import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { get, isUndefined, debounce } from 'lodash'
import { Redirect } from 'react-router-dom'
import { Container, Box, Grid, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ColumnMapper } from '@scoir/data-management'

import { formData } from '@scoir/api'

import { useUploadAPI, getErrorMessage } from '../helpers'

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
}))
export const getFormData = (file, fields) => {
  const data = new FormData()
  data.append('DataFile', file)
  data.append('Fields', JSON.stringify(fields))
  return data
}

const Mapper = ({ columnMappingData, onAddFile }) => {
  const classes = useStyles()
  const API = useUploadAPI()
  const [isValid, setIsValid] = useState(false)
  const [fields, setFields] = useState(get(columnMappingData, 'mappingData.Fields'))
  const [error, setError] = useState(undefined)
  const [isRedirecting, setIsRedirecting] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const upload = debounce(
    () => {
      if (!isUndefined(error)) {
        setError(undefined)
      }

      const body = getFormData(get(columnMappingData, 'file'), fields)
      setIsUploading(true)
      formData
        .post(API, body)
        .then((item) => {
          onAddFile(item)
          setIsRedirecting(true)
        })
        .catch((response) => setError(getErrorMessage(response)))
        .finally(() => setIsUploading(false))
    },
    500,
    { leading: true, trailing: false },
  )
  if (isRedirecting) {
    return <Redirect to={`${import.meta.env.BASE_URL}/engage/end-of-cycle-report`} />
  }
  return (
    <Container maxWidth="lg">
      <Box m={2}>
        <ColumnMapper
          fields={fields}
          mappableItems={get(columnMappingData, 'mappingData.MappableFields')}
          importTypeLabel={'End of Cycle Report'}
          onFieldSet={(fields) => setFields(fields)}
          onValidate={(isValid) => setIsValid(isValid)}
        />
      </Box>
      <Box mb={2}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="flex-end"
        >
          {!isUndefined(error) && (
            <Grid>
              <p
                className={classes.error}
                aria-live="polite"
              >
                {error}
              </p>
            </Grid>
          )}
          <Grid item>
            <Button
              disabled={!isValid || isUploading}
              variant="contained"
              color="primary"
              onClick={() => upload()}
            >
              Upload Student Data
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}
Mapper.propTypes = {
  columnMappingData: PropTypes.object.isRequired,
  onAddFile: PropTypes.func.isRequired,
}

export default Mapper
